module.exports = __webpack_public_path__ + "img/wecheck.a9cf9814.png";